import { Banner } from 'component/Banner/Banner'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { ShareContent } from 'shared/inference/ShareContent'
import { store } from 'store/store'

type Props = {
  fullscreen?: boolean
}

export const ShareBanner2 = observer(({ fullscreen }: Props) => {
  const inference = store.fullscreen?.inferences?.item ?? store.carousel?.carousel.item
  const open = store.carousel.share

  const onCancel = useLatestCallback(async () => {
    store.carousel.share = false
  })

  if (!inference || !open) return null

  return <Banner title={i18n('Share')} onCancel={onCancel} fullscreen={fullscreen}>
    <ShareContent inference={inference} fullscreen={fullscreen} />
  </Banner>
})
